// Union of field arrays into one field indicated by the
// 'from' property in the json schema.
function joinFieldArraysIntoOne(input, schema) {
  const joins = {};
  Object.keys(schema.properties).forEach((property) => {
    const schemaProp = schema.properties[property];
    if (schemaProp && schemaProp.from) {
      const fromField = schemaProp.from;
      joins[fromField] = joins[fromField] ?
        [...new Set([...joins[fromField], ...input[property]])] :
        [...new Set(input[property])];
      delete input[property];
    }
  });
  return { ...input, ...joins };
}

export default joinFieldArraysIntoOne;



// WEBPACK FOOTER //
// ./src/byob-cms/src/formLib/joinFieldArraysIntoOne.js